// services/api.js
import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

// Token management functions
export const getToken = () => {
  return localStorage.getItem('admin_token');
};

export const setToken = (token) => {
  localStorage.setItem('admin_token', token);
};

export const removeToken = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
};

export const setUser = (user) => {
  localStorage.setItem('admin_user', JSON.stringify(user));
};

export const getUser = () => {
  try {
    const user = localStorage.getItem('admin_user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

export const isAuthenticated = () => {
  const token = getToken();
  const user = getUser();
  return !!token && user?.is_admin === true;
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Debug logging in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`🚀 ${config.method?.toUpperCase()} ${config.url}`, config.data || '');
    }
    
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    // Debug logging in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`✅ ${response.config.method?.toUpperCase()} ${response.config.url} - ${response.status}`);
    }
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      console.warn('Unauthorized access - redirecting to login');
      removeToken(); // Use removeToken instead of directly removing 'token'
      window.location.href = '/login';
    }
    
    // Handle 403 Forbidden
    if (error.response?.status === 403) {
      console.error('Forbidden access - insufficient permissions');
      // Optionally redirect to dashboard or show error
    }
    
    // Handle 404 Not Found
    if (error.response?.status === 404) {
      console.warn('Resource not found:', error.config?.url);
    }
    
    // Handle 500 Server Error
    if (error.response?.status >= 500) {
      console.error('Server error:', error.response?.data?.detail || error.message);
    }
    
    return Promise.reject(error);
  }
);

export default api;